export default __webpack_public_path__ + "static/media/29.4a9b49fe.svg";